import { createGStore } from "create-gstore";
import { useState } from "react";

export const useUnread = createGStore(() => {
  const [ticketsUnread, setTicketsUnread] = useState(0);

  return { ticketsUnread, setTicketsUnread };
});
